import { Component, Vue } from 'vue-property-decorator';

import { getComponentProps } from '@/utils/vueUtils';
import TextGeneric from '@/components/TextGeneric/TextGeneric.vue';
import TextGenericItem from '@/common/interfaces/TextGenericItem';

const ContentTextGenericModuleProps = Vue.extend({
  props: getComponentProps<TextGenericItem>({
    Text: '<p>Html text</p>',
    IsCentered: false,
    IsDropLetter: false,
  }),
});

@Component({
  components: {
    TextGeneric,
  },
})
export default class ContentTextGenericModule extends ContentTextGenericModuleProps {}
